import { render, staticRenderFns } from "./TableInspect.vue?vue&type=template&id=db84e1e8&scoped=true"
import script from "./TableInspect.vue?vue&type=script&lang=js"
export * from "./TableInspect.vue?vue&type=script&lang=js"
import style0 from "./TableInspect.vue?vue&type=style&index=0&id=db84e1e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db84e1e8",
  null
  
)

export default component.exports